import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "batteryIcon",
    standalone: false
})
export class BatteryIconPipe implements PipeTransform {
  /** Maps a percentage to the nearest 10% icon; icons exist only for 10-100. */
  transform(percentage: number | null | undefined, stale = false): string {
    const level = Math.min(100, Math.max(10, Math.round(Number(percentage) / 10) * 10));
    return `assets/image/battery/battery_${level}${stale ? '_stale' : ''}_icon.svg`;
  }
}
